import {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {favoriteTemplateThunk} from '~/GalleryPB/api/favorites';
import {isIn3AcrossABTest} from '~/GalleryPB/experiments';
import {FavoritesHeart} from '~/GalleryPB/FavoritesHeart';
import {selectFavorites} from '~/GalleryPB/reducers/favorites';
import {LabelPremium} from '~/GalleryPB/Template/components/QuickView/components/LabelPremium/LabelPremium';
import {Typography} from '~library/atoms/Typography';

import './Header.sass';

type HeaderProps = {
  title?: string;
  isPremiumTemplate?: boolean;
  templateId?: string;
  onClose: () => void;
  openQuickView: (templateId: string | undefined) => void;
};

export const Header = ({
  title,
  isPremiumTemplate,
  templateId,
  onClose,
  openQuickView,
}: HeaderProps) => {
  const dispatch = useDispatch();
  const {favorites} = useSelector(selectFavorites);
  const favorited = favorites.includes(templateId);
  const in3AcrossABTest = isIn3AcrossABTest();

  const onFavoriteClick = useCallback(() => {
    if (!window.isAuthenticated) {
      onClose();
    }

    openQuickView(templateId);

    dispatch(
      // @ts-expect-error function not typed
      favoriteTemplateThunk(templateId, isPremiumTemplate, favorited ? 'delete' : 'post')
    );
  }, [dispatch, templateId, isPremiumTemplate, favorited, onClose, openQuickView]);

  return (
    <div className="quick-view__content__header">
      {isPremiumTemplate && <LabelPremium className="quick-view__content__header__label_premium" />}
      <div className="quick-view__content__header__content">
        <Typography variant="header5" className="quick-view__content__header__content__title">
          {title}
        </Typography>
        <FavoritesHeart
          identifier={templateId as string}
          onClick={onFavoriteClick}
          favorited={favorites.includes(templateId)}
          ratio={0.75}
          variant={in3AcrossABTest}
        />
      </div>
    </div>
  );
};
